import { createUseStyles } from 'react-jss'
import { defaultBorderRadius, transitionShort } from '../../../styles/const/common'
import { fontFamily, fontWeightBold, fontWeightRegular } from '../../../styles/typography'
import { black, darkGrey, blue, lightGrey } from '../../../styles/const/colors'
import { phonesDown } from '../../../styles/const/breakpoints'

export default createUseStyles({
  tooltip: {
    display: 'none',
    position: 'absolute',
    top: '-185px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 305,
    border: `2px solid ${lightGrey}`,
    borderRadius: defaultBorderRadius,
    backgroundColor: 'white',
    transition: transitionShort,
    fontSize: 12,
    lineHeight: '14px',
    color: darkGrey,
    padding: 20
  },
  tooltipArrow: {
    display: 'inline-block',
    content: '',
    position: 'absolute',
    width: 13,
    height: 13,
    background: 'white',
    border: `2px solid ${lightGrey}`,
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 57%) rotate(45deg)',
    borderTop: 'none',
    borderLeft: 'none'
  },
  tooltipTitle: {
    fontSize: 16,
    fontWeight: fontWeightBold,
    color: blue,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& svg': {
      width: 30,
      height: 30
    },

    '& path': {
      fill: blue
    }
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 263,

    borderRadius: defaultBorderRadius,
    transition: transitionShort,
    fontSize: 14,
    padding: '0 14px',
    height: 37,
    fontWeight: fontWeightRegular,
    cursor: 'pointer',
    color: black,
    backgroundColor: 'white',
    fontFamily: fontFamily,
    border: `2px solid ${lightGrey}`,

    // show tooltip
    '&:hover .tooltip': {
      display: 'block'
    }
  },
  [`@media screen and (${phonesDown})`]: {
    container: {
      height: 32
    }
  }
})
